import type { Profile } from "@/core/types";

export const isAddressCompleted = (profile: Profile): boolean => {
  return (
    !!profile?.address?.city &&
    !!profile?.address?.state &&
    !!profile?.address?.street &&
    !!profile?.address?.zip_code
  );
};

export const isEmergencyContactCompleted = (profile: Profile): boolean => {
  return !!profile?.emergency_contact_number && !!profile?.emergency_contact_person;
};

export const hasPrimaryCareProvider = (profile: Profile): boolean => {
  return (
    // Either pcp details are filled in, or you selected no_pcp
    (!!profile?.pcp_name && !!profile?.pcp_location) || !!profile?.no_pcp
  );
};

export const hasPreferredNameAndPronouns = (profile: Profile): boolean => {
  return profile.preferred_name != null && profile.preferred_pronouns != null;
};

export const isProfileCompleted = (profile: Profile): boolean => {
  return (
    isAddressCompleted(profile) &&
    isEmergencyContactCompleted(profile) &&
    hasPrimaryCareProvider(profile) &&
    hasPreferredNameAndPronouns(profile)
  );
};
